import * as THREE from 'three';
import { pando3D } from './setup';

export const MATERIAL = {

  load: () => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < pando3D.data.stacks.length; i += 1) {
      MATERIAL.draw(pando3D.data.stacks[i]);
    }
  },

  draw: (stack) => {
    const isPipe = stack.ref_id === '168870';

    let geometry;
    if (isPipe) {
      geometry = new THREE.CylinderGeometry(stack.width / 2, stack.height / 2, stack.length, 64, 64, true);
    } else {
      geometry = new THREE.BoxGeometry(stack.width, stack.height, stack.length);
    }
    if (!pando3D.materialColors[stack.material_code]) {
      pando3D.materialColors[stack.material_code] = MATERIAL.getRandomColor();
    }

    // DEFAULT: WHILE LISTING MATERIAL IT WILL START AT CENTER
    // IN OUR CASE, WE SHOULD START AT THE CORNOR OF THE TRUCK
    // WE HAVE TO TRANSFORM THE POSITION FOR ALL THE MATERIAL
    let pos = {};
    pos = MATERIAL.transformLeftCorner(
      pando3D.containerVectors, (stack.width / 2) + stack.X,
      (stack.height / 2) + stack.Y,
      (-stack.length / 2) - stack.Z,
    );

    const materialArray = [];

    if (stack.material_code.indexOf('Pallet') !== -1) {
      const mat1 = MATERIAL.createPallet('top');
      const mat2 = MATERIAL.createPallet('bottom');
      const mat3 = MATERIAL.createPallet('bside');
      const mat4 = MATERIAL.createPallet('dside');

      // DRAW MATERIAL ALL SIDE(RECTANGLE[6])
      materialArray.push(mat4);
      materialArray.push(mat4);
      materialArray.push(mat1);
      materialArray.push(mat2);
      materialArray.push(mat3);
      materialArray.push(mat3);
    } else if (stack.material_code.indexOf('Carton') !== -1) {
      const mat1 = MATERIAL.createCarton('top');
      const mat2 = MATERIAL.createCarton('bottom');
      const mat3 = MATERIAL.createCarton('bside');
      const mat4 = MATERIAL.createCarton('dside');

      // DRAW MATERIAL ALL SIDE(RECTANGLE[6])
      materialArray.push(mat4);
      materialArray.push(mat4);
      materialArray.push(mat1);
      materialArray.push(mat2);
      materialArray.push(mat3);
      materialArray.push(mat3);
    } else {
      const mat1 = MATERIAL.createBase(stack);
      const mat2 = MATERIAL.createBase(stack);
      const mat3 = MATERIAL.createBase(stack);


      // DRAW MATERIAL ALL SIDE(RECTANGLE[6])
      materialArray.push(mat1);
      materialArray.push(mat1);
      materialArray.push(mat2);
      materialArray.push(mat2);
      materialArray.push(mat3);
      materialArray.push(mat3);
    }

    // DRAW MARGIN|EDGE
    const materialObject = new THREE.Mesh(geometry, materialArray);
    if (isPipe) {
      materialObject.rotation.x = 1.5708;
      materialObject.transparent = true;
      materialObject.opacity = 0.25;
      materialObject.openEnded = true;
    }
    materialObject.position.x = Math.floor(pos.x);
    materialObject.position.y = Math.floor(pos.y);
    materialObject.position.z = Math.floor(pos.z);
    materialObject.ref_id = stack.ref_id;
    materialObject.ref_id_text = `Ref Id: ${stack.ref_id}`;
    materialObject.material_code = `Material Code: ${stack.material_code}`;
    materialObject.name = `X:${stack.X} Y:${stack.Y} Z:${stack.Z}`;

    materialObject.matrixAutoUpdate = false;
    materialObject.updateMatrix();
    pando3D.materialScenes.push(materialObject);

    const edges = new THREE.EdgesGeometry(geometry);
    const line = new THREE.LineSegments(edges, new THREE.LineBasicMaterial({ color: 0x000000 }));

    if (isPipe) {
      line.rotation.x = 1.5708;
    }

    line.position.x = Math.floor(pos.x);
    line.position.y = Math.floor(pos.y);
    line.position.z = Math.floor(pos.z);
    materialObject.line = line;
    pando3D.scene.add(materialObject);
    pando3D.scene.add(line);
  },

  // createBase: (stack) => {
  //   const color = pando3D.materialColors[stack.ref_id] || '#00ffff';
  //   return new THREE.MeshBasicMaterial({
  //     color,
  //     side: THREE.DoubleSide,
  //     opacity: 0.5,
  //     transparent: false,
  //   });
  // },

  createPallet: (direction) => {
    let texture;
    const loader = new THREE.TextureLoader();
    texture = new THREE.TextureLoader().load('/static/textures/pallet-top.png');
    if (direction === 'top') {
      texture = new THREE.TextureLoader().load('/static/textures/pallet-top.png');
    }
    if (direction === 'bottom') {
      texture = new THREE.TextureLoader().load('/static/textures/pallet-bottom.png');
    }
    if (direction === 'dside') {
      texture = new THREE.TextureLoader().load('/static/textures/pallet-depth-side.png');
    }
    if (direction === 'bside') {
      texture = new THREE.TextureLoader().load('/static/textures/pallet-breadth-side.png');
    }
    return new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
      opacity: 1,
    });
  },


  createCarton: (direction) => {
    let texture;
    const loader = new THREE.TextureLoader();
    texture = new THREE.TextureLoader().load('/static/textures/box-vertical.png');
    if (direction === 'top') {
      texture = new THREE.TextureLoader().load('/static/textures/box-vertical.png');
    }
    if (direction === 'bottom') {
      texture = new THREE.TextureLoader().load('/static/textures/box-vertical.png');
    }
    if (direction === 'dside') {
      texture = new THREE.TextureLoader().load('/static/textures/box-vertical.png');
    }
    if (direction === 'bside') {
      texture = new THREE.TextureLoader().load('/static/textures/box-vertical.png');
    }
    return new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
      opacity: 1,
    });
  },

  createBase: (stack) => {
    const color = pando3D.materialColors[stack.material_code] || '#00ffff';
    return new THREE.MeshBasicMaterial({
      color,
      side: THREE.DoubleSide,
      opacity: 0.5,
      transparent: false,
    });
  },

  transformLeftCorner: (offsets, x, y, z) => {
    x -= offsets.XOffset;
    z = -z + offsets.ZOffset;
    return new THREE.Vector3(x, y, z);
  },

  getRandomColor: () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i += 1) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  },
};

export default MATERIAL;
